import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useDownload } from '../../hooks/Download/useDownload'

export const useHoliday = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [holiday, setHoliday] = useState(false)
  const { getNewHolidays, removeHoliday, holidays } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  // const [pdfCsvData, setPdfCsvData] = useState([])
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();

  const getAllHolidays = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_HOLIDAYS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewHolidays(data.data)
        // setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })

      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
      getPdfCsvData('GET_ALL_HOLIDAYS', dto)
  }

  const addHoliday = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_HOLIDAY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewHolidays([...holidays, data])
        // getAllHolidays();
        toastMessage('SalesChannelType  Added Successfully', success)
        history.push(ROUTES.HOLIDAY_SETUP)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteHolidays = (dto, setSelected) => {
    setLoading(true)
    axios
      .delete(API.DELETE_HOLIDAYS(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        toastMessage(`${dto.ids.length} holidays Deleted Successfully`, success)
        // dto.ids.map((item) => removeHoliday(item))        
        setSelected([])
        history.push(ROUTES.HOLIDAY_SETUP)

      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const editHoliday = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_HOLIDAY, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Holiday  Update Successfully', success)
        history.push(ROUTES.HOLIDAY_SETUP)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  
 const getHoliday = (id)=>{
   let h= {};
    holidays?.forEach(item=>{
       if(item._id === id){
          h= item;
  }})
  return h;
 }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // data.data.map((item) => addNewReg(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addHoliday,
    getAllHolidays,
    deleteHolidays,
    editHoliday,
    BulkUpload,
    getHoliday,
    loading,
    paginate,
    pdfCsvData
  }
}
